import { createSlice } from "@reduxjs/toolkit";
export type ViewType = "table" | "card" | "detail";

const initialState: { data: ViewType } = {
  data: "table",
};

export const CalendarsListViewTypeSlice = createSlice({
  name: "CalendarsListViewType",
  initialState,
  reducers: {
    updateCalendarsListViewType(state, action) {
      state.data = action.payload;
    },
  },
});
export const { updateCalendarsListViewType } =
  CalendarsListViewTypeSlice.actions;

